import { createContext, useContext } from "react";

const Nd1SessionContext = createContext({
  currentUser: null,
  setCurrentUser: () => {},
  authToken: null,
});

export function Nd1SessionProvider({ currentUser, setCurrentUser, authToken, children }) {
  return (
    <Nd1SessionContext.Provider value={{ currentUser, setCurrentUser, authToken }}>
      {children}
    </Nd1SessionContext.Provider>
  );
}

export function useNd1Session() {
  return useContext(Nd1SessionContext);
}
